import { Box, Typography } from "@mui/material";
import useColors from "../../../../../../api/hooks/useColors";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import { nonHumanIdentityHasTags } from "./checkNonHumanIdentityData";

const TagsNonHumanIdentityView = ({ entityData }) => {
  const colors = useColors();
  return nonHumanIdentityHasTags(entityData) ? (
    <Box>
      {entityData?.aws_common_data?.tags?.length > 0 && (
        <Box>
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            {entityData?.aws_common_data?.tags.map((tag, index) => (
              <Box
                key={index}
                display={"flex"}
                flexDirection={"column"}
                gap={0.5}
              >
                <Box display={"flex"} gap={1}>
                  <IntegrationImage
                    name={"aws"}
                    width={"24px"}
                    newLogo={true}
                  />
                  <Typography variant="overline" fontWeight={500}>
                    Key
                  </Typography>
                </Box>

                <Typography
                  ml={4}
                  variant="caption"
                  sx={{ color: colors.text_secondary }}
                >
                  {tag.key}
                </Typography>

                <Typography variant="overline" fontWeight={500} ml={3.5}>
                  Value
                </Typography>
                <Typography
                  ml={4}
                  variant="caption"
                  sx={{ color: colors.text_secondary }}
                >
                  {tag.value}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      )}
      {entityData?.azure_keyvault_resource_data?.resource_tags?.length > 0 && (
        <Box>
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            {entityData.azure_keyvault_resource_data.resource_tags.map(
              (tag, index) => (
                <Box
                  key={index}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={0.5}
                >
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"azure"}
                      width={"20px"}
                      newLogo={true}
                    />
                    <Typography variant="overline" fontWeight={500}>
                      Key
                    </Typography>
                  </Box>

                  <Typography
                    ml={4}
                    variant="caption"
                    sx={{ color: colors.text_secondary }}
                  >
                    {tag.key}
                  </Typography>

                  <Typography variant="overline" fontWeight={500} ml={3.5}>
                    Value
                  </Typography>
                  <Typography
                    ml={4}
                    variant="caption"
                    sx={{ color: colors.text_secondary }}
                  >
                    {tag.value}
                  </Typography>
                </Box>
              )
            )}
          </Box>
        </Box>
      )}
      {entityData?.microsoft_entra_id_application_data?.tags?.length > 0 && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <IntegrationImage
              name={"microsoft_entra_id"}
              width={"20px"}
              newLogo={true}
            />
            <Typography variant={"subtitle2"}>Tags</Typography>
          </Box>
          <Box
            display={"flex"}
            flexDirection={"column"}
            gap={1}
            ml={2}
            maxHeight={150}
            overflow="auto"
          >
            {entityData.microsoft_entra_id_application_data.tags.map(
              (tag, index) => (
                <Box
                  key={index}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={0.5}
                >
                  <TextIntegrationStyle title={""} value={tag} />
                </Box>
              )
            )}
          </Box>
        </Box>
      )}
    </Box>
  ) : null;
};

export default TagsNonHumanIdentityView;
